import { render } from "./postcode-field.vue?vue&type=template&id=89b840f8"
import script from "./postcode-field.vue?vue&type=script&lang=js"
export * from "./postcode-field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__